<template>
  <el-dialog :visible="visible" width="600px" custom-class="invoice-audit-dialog" :close-on-click-modal="false"
    :before-close="close" @open="initialize">
    <div slot="title" class="audit-title">
      <span>{{ record.isView ? '开票详情' : '开票处理' }}</span>
      <el-tag size="mini" :type="record.isView ? (record.status == 1 ? 'success' : 'info') : 'warning'">
        {{ record.isView ? (record.statusName || (record.status == 1 ? '已开票' : '不支持开票')) : '待处理' }}
      </el-tag>
    </div>
    <div v-loading="loading">
      <section class="audit-summary">
        <div class="audit-summary-top">
          <div><div class="audit-muted">开票申请人</div><div>{{ detail.userName || record.userName || '--' }}</div></div>
          <div class="audit-amount"><div class="audit-muted">申请开票金额</div><strong>{{ money(detail.amount != null ? detail.amount : record.amount) }}</strong></div>
        </div>
        <div class="audit-orders-heading">
          <span>关联订单 {{ orders.length }} 笔</span>
          <el-button type="text" @click="expanded = !expanded">{{ expanded ? '收起' : '全部展示' }}</el-button>
        </div>
        <div v-if="expanded" class="audit-orders">
          <template v-if="orders.length">
            <div class="audit-order-row audit-muted"><span>订单号</span><span>订单金额</span></div>
            <div v-for="(order, index) in orders" :key="order.id || index" class="audit-order-row">
              <span>{{ order.orderNo || '--' }}</span>
              <span>{{ order.paidAmount != null ? money(order.paidAmount) : '--' }}</span>
            </div>
          </template>
          <div v-else class="audit-muted">暂无关联订单</div>
        </div>
      </section>
      <template v-if="record.isView">
        <div class="audit-view-section" v-if="form.url">
          <div class="audit-label">发票文件</div>
          <el-image v-if="isImage" :src="form.url" :preview-src-list="[form.url]" fit="contain" class="audit-preview" />
          <a v-else :href="form.url" target="_blank" rel="noopener noreferrer" class="audit-file-link">查看发票文件 <i class="el-icon-link"></i></a>
        </div>
        <div class="audit-view-section"><div class="audit-label">{{ record.status == 1 ? '备注' : '不支持开票原因' }}</div><div class="audit-text">{{ form.auditReMarks || '无' }}</div></div>
      </template>
      <el-tabs v-else v-model="tab" class="audit-tabs" :before-leave="canSwitch">
        <el-tab-pane label="上传发票" name="upload">
          <div class="audit-notice">请直接上传已开具的发票文件。</div>
          <el-form ref="uploadForm" :model="form" label-position="top">
            <el-form-item label="发票文件" prop="url" :rules="[{ required: true, message: '请上传发票文件', trigger: 'change' }]">
              <InvoiceFileUpload v-model="form.url" :disabled="submitting || loading" @uploading="uploading = $event" />
              <div class="audit-upload-hint">仅支持上传一个发票文件。</div>
            </el-form-item>
            <el-form-item>
              <div slot="label">备注 <span class="audit-optional">（选填）</span></div>
              <el-input v-model="form.auditReMarks" type="textarea" :rows="3" placeholder="请输入发票相关备注" :disabled="submitting" />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="不支持开票" name="reject">
          <el-form ref="rejectForm" :model="rejection" label-position="top">
            <el-form-item label="不支持开票原因" prop="reason" :rules="[{ required: true, whitespace: true, message: '请填写不支持开票的具体原因', trigger: 'blur' }]">
              <el-input v-model="rejection.reason" type="textarea" :rows="6" placeholder="请说明不支持开票的具体原因" :disabled="submitting" />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer" class="audit-footer">
      <el-button :disabled="submitting || uploading" @click="close">{{ record.isView ? '关闭' : '取消' }}</el-button>
      <el-button v-if="!record.isView" type="primary" :loading="submitting" :disabled="uploading || loading || loadFailed" @click="submit">
        {{ tab === 'upload' ? '确认上传' : '确认不支持开票' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import InvoiceFileUpload from '@/views/orderCenter/components/InvoiceFileUpload.vue';
import { orderinvoicedetail, orderinvoiceaudit } from '@/api/order';
export default {
  name: 'InvoiceAuditDialog',
  components: { InvoiceFileUpload },
  props: { visible: Boolean, record: { type: Object, default: () => ({}) } },
  data() {
    return { detail: {}, tab: 'upload', expanded: false, loading: false, loadFailed: false,
      uploading: false, submitting: false, requestId: 0,
      form: { url: '', auditReMarks: '' }, rejection: { reason: '' } };
  },
  computed: {
    orders() {
      if (Array.isArray(this.detail.orders)) return this.detail.orders;
      return Array.isArray(this.record.orders) ? this.record.orders : [];
    },
    isImage() { return /\.(jpe?g|png)(?:[?#]|$)/i.test(this.form.url); },
  },
  methods: {
    money(value) { return '¥' + (Number(value) || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    canSwitch() { return !this.submitting && !this.uploading; },
    close() {
      if (this.submitting || this.uploading) return;
      this.requestId++;
      this.$emit('update:visible', false);
    },
    async initialize() {
      const requestId = ++this.requestId;
      this.tab = 'upload';
      this.expanded = false;
      this.detail = {};
      this.form = { url: this.record.url || '', auditReMarks: this.record.auditReMarks || '' };
      this.rejection = { reason: '' };
      this.loading = true;
      this.loadFailed = false;
      this.$nextTick(() => {
        if (this.$refs.uploadForm) this.$refs.uploadForm.clearValidate();
        if (this.$refs.rejectForm) this.$refs.rejectForm.clearValidate();
      });
      try {
        const res = await orderinvoicedetail({ id: this.record.id });
        if (requestId !== this.requestId) return;
        if (res.code != 1) throw new Error(res.msg || '获取开票详情失败');
        this.detail = res.data || {};
        this.form.url = this.detail.url || this.detail.invoiceUrl || this.record.url || '';
        this.form.auditReMarks = this.detail.auditReMarks || this.record.auditReMarks || '';
      } catch (error) {
        if (requestId === this.requestId) {
          this.loadFailed = true;
          this.$message.error(error.message || '获取详情失败，请重新打开');
        }
      } finally { if (requestId === this.requestId) this.loading = false; }
    },
    async submit() {
      if (this.record.isView || this.submitting || this.uploading || this.loading || this.loadFailed) return;
      const approve = this.tab === 'upload';
      const valid = await this.$refs[approve ? 'uploadForm' : 'rejectForm'].validate().catch(() => false);
      if (!valid) return;
      this.submitting = true;
      try {
        const res = await orderinvoiceaudit({ id: this.record.id, status: approve ? 1 : 2,
          url: approve ? this.form.url : '', auditReMarks: approve ? this.form.auditReMarks : this.rejection.reason.trim() });
        if (res.code != 1) throw new Error(res.msg || '审核失败');
        this.$message.success('审核成功');
        this.$emit('success');
        this.$emit('update:visible', false);
      } catch (error) { this.$message.error(error.message || '审核失败，请重试'); }
      finally { this.submitting = false; }
    },
  },
};
</script>

<style lang="scss">
.el-dialog.invoice-audit-dialog {
  background: #fff; border-radius: 8px; color: #152238;
  .el-dialog__header { display: block !important; padding: 28px 24px; }
  .el-dialog__headerbtn { top: 30px; right: 24px; }
  .el-dialog__body { padding: 0 24px 8px; background: #fff; border-radius: 0; }
  .audit-title { display: flex; align-items: center; gap: 12px; font-size: 18px; font-weight: 500; }
  .audit-summary { background: #f5f7fa; border-radius: 4px; padding: 18px 16px; }
  .audit-summary-top { display: flex; justify-content: space-between; align-items: center; gap: 16px; padding-bottom: 18px; line-height: 24px; }
  .audit-muted, .audit-optional { color: #909399; font-size: 12px; }
  .audit-amount { text-align: right; strong { font-size: 20px; font-weight: 400; line-height: 30px; } }
  .audit-orders-heading { display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px solid #dfe4ed; .el-button { padding: 0; font-weight: 400; } }
  .audit-orders { margin-top: 14px; max-height: 180px; overflow: auto; }
  .audit-order-row { display: flex; justify-content: space-between; gap: 16px; padding: 9px 0; border-top: 1px solid #e4e7ed; }
  .audit-tabs { margin-top: 12px; .el-tabs__header { margin-bottom: 20px; } .el-tabs__nav-wrap::after { height: 1px; } .el-tabs__item { font-weight: 400; } }
  .audit-notice { margin-bottom: 18px; padding: 10px 12px; background: #ecf5ff; border-radius: 4px; color: #409eff; font-size: 12px; line-height: 20px; }
  .el-form-item { margin-bottom: 24px; }
  .el-form-item__label { padding-bottom: 10px; line-height: 22px; color: #303133; }
  .el-textarea__inner { padding: 10px 12px; line-height: 24px; }
  .audit-upload-hint { margin-top: 6px; font-size: 12px; line-height: 20px; color: #909399; }
  .invoice-file-upload .el-upload-dragger { height: 164px; }
  .audit-view-section { margin: 24px 0; }
  .audit-label { margin-bottom: 12px; }
  .audit-text { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 24px; }
  .audit-preview { display: block; width: 100%; height: 240px; }
  .audit-file-link { color: #409eff; }
  .el-dialog__footer { padding: 16px 24px; border-top: 1px solid #e4e7ed; }
  .audit-footer { display: flex; justify-content: flex-end; gap: 10px; .el-button { margin: 0; padding: 12px 18px; } }
}
</style>
